var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccd1d9;}.cls-2{fill:#fff;isolation:isolate;opacity:0.7;}.cls-3{fill:#e6e9ed;}.cls-4{fill:#f2f2f2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.62,26.72v6.56a30.62,30.62,0,1,1-61.24,0V26.72a30.62,30.62,0,0,0,61.24,0Z",
    transform: "translate(-4 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35,7A25,25,0,1,1,10,32,25,25,0,0,1,35,7ZM50,31.5a15,15,0,1,0-15,15A15,15,0,0,0,50,31.5Z",
    transform: "translate(-4 -1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66,32A31,31,0,1,1,35,1,31,31,0,0,1,66,32Zm-8.86,0A22.14,22.14,0,1,0,35,54.14,22.16,22.16,0,0,0,57.14,32Z",
    transform: "translate(-4 -1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35,12A20,20,0,1,1,15,32,20,20,0,0,1,35,12Z",
    transform: "translate(-4 -1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultNode);
export default __webpack_public_path__ + "static/media/default-node.3467196ffca38930f037eaa02d3656fe.svg";
export { ForwardRef as ReactComponent };